type QueryParams = Record<
  string,
  string | number | boolean | string[] | undefined
>;

export const buildQueryString = (params: QueryParams) => {
  const arrayParams = Object.entries(params).reduce(
    (acc, [key, value]) => {
      if (value === null || value === undefined) return acc;
      if (Array.isArray(value)) {
        value.forEach((item) => {
          acc.push([key, item]);
        });
        return acc;
      }
      acc.push([key, String(value)]);
      return acc;
    },
    [] as [string, string][]
  );

  const urlParams = new URLSearchParams(arrayParams);

  return urlParams.toString();
};
